<app-popup
  [heading]="'📍 Location Intelligence'"
  [showFooterButtons]="false"
  [showCloseIcon]="true"
  [isFullScreen]="true"
  (cancelClicked)="onClose()"
>
  <div class="arcgis-container">
    <!-- Header Section with Coordinates and Actions -->
    <div class="header-section">
      <div class="header-left">
        @if (recordName) {
          <div class="record-name">
            <h2>{{ recordName }}</h2>
          </div>
        }
        <div class="coordinates-info">
          <!-- @if (!isLoading && !errorMessage && intersectionData.length > 0) {
            <div class="coordinate-item layers-count">
              <span class="label">Layers Found:</span>
              <span class="value">{{ intersectionData.length }}</span>
            </div>
          } -->
          <div class="coordinate-item">
            <span class="label">Latitude:</span>
            <span class="value">{{ latitude }}</span>
          </div>
          <div class="coordinate-item">
            <span class="label">Longitude:</span>
            <span class="value">{{ longitude }}</span>
          </div>
        </div>
      </div>
      <button class="goto-map-btn" (click)="onViewOnMap()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 640 640"
          width="16"
          height="16"
        >
          <path
            d="M576 112C576 100.9 570.3 90.6 560.8 84.8C551.3 79 539.6 78.4 529.7 83.4L413.5 141.5L234.1 81.6C226 78.9 217.3 79.5 209.7 83.3L81.7 147.3C70.8 152.8 64 163.9 64 176L64 528C64 539.1 69.7 549.4 79.2 555.2C88.7 561 100.4 561.6 110.3 556.6L226.4 498.5L399.7 556.3C395.4 549.9 391.2 543.2 387.1 536.4C376.1 518.1 365.2 497.1 357.1 474.6L255.9 440.9L255.9 156.4L383.9 199.1L383.9 298.4C414.9 262.6 460.9 240 511.9 240C534.5 240 556.1 244.4 575.9 252.5L576 112zM512 288C445.7 288 392 340.8 392 405.9C392 474.8 456.1 556.3 490.6 595.2C502.2 608.2 521.9 608.2 533.5 595.2C568 556.3 632.1 474.8 632.1 405.9C632.1 340.8 578.4 288 512.1 288zM472 408C472 385.9 489.9 368 512 368C534.1 368 552 385.9 552 408C552 430.1 534.1 448 512 448C489.9 448 472 430.1 472 408z"
          />
        </svg>
        <span>View in Map</span>
      </button>
    </div>

    <!-- Loading State -->
    @if (isLoading) {
      <div class="loading-container">
        <div class="spinner"></div>
        <p>{{ currentLoadingMessage }}</p>
      </div>
    }

    <!-- Error State -->
    @if (errorMessage && !isLoading) {
      <div class="error-container">
        <div class="error-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 512 512"
            fill="#dc3545"
          >
            <path
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"
            />
          </svg>
        </div>
        <p class="error-message">{{ errorMessage }}</p>
        <button class="retry-btn" (click)="retry()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 512 512"
          >
            <path
              d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"
            />
          </svg>
          Retry
        </button>
      </div>
    }

    <!-- Data Sections -->
    @if (!isLoading && !errorMessage && intersectionData.length > 0) {
      <div class="data-sections">
        @for (section of intersectionData; track section.name) {
          <div
            class="data-section"
            [class.expanded]="isSectionExpanded(section.name)"
          >
            <div
              class="section-header"
              (click)="toggleSection(section.name)"
              (keydown.enter)="toggleSection(section.name)"
              (keydown.space)="
                toggleSection(section.name); $event.preventDefault()
              "
              tabindex="0"
              role="button"
              [attr.aria-expanded]="isSectionExpanded(section.name)"
            >
              <div class="section-title">
                @if (isSectionExpanded(section.name)) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 512 512"
                    fill="#6c757d"
                  >
                    <path
                      d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                    />
                  </svg>
                } @else {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 320 512"
                    fill="#6c757d"
                  >
                    <path
                      d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                    />
                  </svg>
                }
                <h3>{{ section.name }}</h3>
              </div>
            </div>

            @if (isSectionExpanded(section.name)) {
              <div class="section-content">
                <div class="properties-grid">
                  @for (
                    property of getDataProperties(section.data);
                    track property.key
                  ) {
                    @if (isNestedProperty(property.key)) {
                      <!-- Nested collapsible section -->
                      <div class="nested-section-wrapper">
                        <div
                          class="nested-section-header"
                          (click)="
                            toggleNestedProperty(section.name, property.key)
                          "
                          (keydown.enter)="
                            toggleNestedProperty(section.name, property.key)
                          "
                          (keydown.space)="
                            toggleNestedProperty(section.name, property.key);
                            $event.preventDefault()
                          "
                          tabindex="0"
                          role="button"
                          [attr.aria-expanded]="
                            isNestedPropertyExpanded(section.name, property.key)
                          "
                        >
                          @if (
                            isNestedPropertyExpanded(section.name, property.key)
                          ) {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 512 512"
                              fill="#6c757d"
                            >
                              <path
                                d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
                              />
                            </svg>
                          } @else {
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="14"
                              height="14"
                              viewBox="0 0 320 512"
                              fill="#6c757d"
                            >
                              <path
                                d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                              />
                            </svg>
                          }
                          <span class="nested-section-title">{{
                            getNestedPropertyName(property.key)
                          }}</span>
                        </div>
                        @if (
                          isNestedPropertyExpanded(section.name, property.key)
                        ) {
                          <div class="nested-properties-grid">
                            @for (
                              nestedProp of getNestedProperties(property.value);
                              track nestedProp.key
                            ) {
                              <div class="property-item">
                                <span class="property-name">{{
                                  formatPropertyName(nestedProp.key)
                                }}</span>
                                <span class="property-value">{{
                                  formatPropertyValue(
                                    nestedProp.value,
                                    nestedProp.key
                                  )
                                }}</span>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    } @else {
                      <!-- Regular property -->
                      <div class="property-item">
                        <span class="property-name">{{
                          formatPropertyName(property.key)
                        }}</span>
                        <span class="property-value">{{
                          formatPropertyValue(property.value, property.key)
                        }}</span>
                      </div>
                    }
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }

    <!-- No Data State -->
    @if (!isLoading && !errorMessage && intersectionData.length === 0) {
      <div class="no-data-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 512 512"
          fill="#6c757d"
        >
          <path
            d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
          />
        </svg>
        <p>No location intelligence data available for this location.</p>
      </div>
    }
  </div>
</app-popup>
